<!--
  Vue wrapper for Bryntum ResourceFilter
-->

<template>

</template>

<script>

import { Base, Collection, EventStore, Mask, Rectangle, ResourceFilter, Scroller, Store, Widget } from '@bryntum/scheduler';

import WrapperHelper from './WrapperHelper.js';
import WrapperHelperVue2 from './WrapperHelperVue2.js';

export default {

    name : 'BryntumResourceFilter',

    props : {

         // Configs only
        activateOnMouseover    : { type : Boolean, default : undefined },
        adopt                  : { type : [HTMLElement, String], default : undefined },
        align                  : { type : [Object, String], default : undefined },
        anchor                 : { type : Boolean, default : undefined },
        appendTo               : { type : [HTMLElement, String], default : undefined },
        centered               : { type : Boolean, default : undefined },
        cls                    : { type : [String, Object], default : undefined },
        config                 : { type : Object, default : undefined },
        constrainTo            : { type : [HTMLElement, Widget, Rectangle], default : undefined },
        contentElementCls      : { type : [String, Object], default : undefined },
        defaultBindProperty    : { type : String, default : undefined },
        dock                   : { type : String, default : undefined },
        draggable              : { type : [Boolean, Object], default : undefined },
        eventStore             : { type : EventStore, default : undefined },
        floating               : { type : Boolean, default : undefined },
        hideAnimation          : { type : [Boolean, Object], default : undefined },
        htmlCls                : { type : [String, Object], default : undefined },
        insertBefore           : { type : [HTMLElement, String], default : undefined },
        insertFirst            : { type : [HTMLElement, String], default : undefined },
        itemTpl                : { type : Function, default : undefined },
        listeners              : { type : Object, default : undefined },
        localeClass            : { type : Base, default : undefined },
        localizableProperties  : { type : Array, default : undefined },
        maskDefaults           : { type : [Object, Mask], default : undefined },
        masked                 : { type : [Boolean, String, Object, Mask], default : undefined },
        monitorResize          : { type : Boolean, default : undefined },
        multiSelect            : { type : Boolean, default : undefined },
        owner                  : { type : Widget, default : undefined },
        positioned             : { type : Boolean, default : undefined },
        preventTooltipOnTouch  : { type : Boolean, default : undefined },
        ripple                 : { type : [Boolean, Object], default : undefined },
        rootElement            : { type : ShadowRoot, default : undefined },
        scrollAction           : { type : String, default : undefined },
        selectAllItem          : { type : [Boolean, String], default : undefined },
        selected               : { type : [Collection, Object], default : undefined },
        showAnimation          : { type : [Boolean, Object], default : undefined },
        store                  : { type : [Object, Store], default : undefined },
        tab                    : { type : [Boolean, Object], default : undefined },
        tag                    : { type : String, default : undefined },
        textAlign              : { type : String, default : undefined },
        title                  : { type : String, default : undefined },
        toggleAllIfCtrlPressed : { type : Boolean, default : undefined },
        weight                 : { type : Number, default : undefined },

         // Configs and properties
        alignSelf  : { type : [String], default : undefined },
        content    : { type : [String], default : undefined },
        dataset    : { type : [Object], default : undefined },
        disabled   : { type : [Boolean], default : undefined },
        extraData  : { type : [Boolean, Number, Object, String], default : undefined },
        flex       : { type : [Number, String], default : undefined },
        height     : { type : [Number, String], default : undefined },
        hidden     : { type : [Boolean], default : undefined },
        html       : { type : [String], default : undefined },
        id         : { type : [String], default : undefined },
        items      : { type : [Array], default : undefined },
        margin     : { type : [Number, String], default : undefined },
        maxHeight  : { type : [Number, String], default : undefined },
        maxWidth   : { type : [Number, String], default : undefined },
        minHeight  : { type : [Number, String], default : undefined },
        minWidth   : { type : [Number, String], default : undefined },
        readOnly   : { type : [Boolean], default : undefined },
        scrollable : { type : [Boolean, Scroller, Object], default : undefined },
        tooltip    : { type : [Object, String], default : undefined },
        width      : { type : [Number, String], default : undefined },
        x          : { type : [Number], default : undefined },
        y          : { type : [Number], default : undefined },

         // Properties only
        anchorSize : { type : Array, default : undefined },

         // Events
        onBeforeDestroy : { type : Function, default : undefined },
        onBeforeHide    : { type : Function, default : undefined },
        onBeforeShow    : { type : Function, default : undefined },
        onCatchAll      : { type : Function, default : undefined },
        onDestroy       : { type : Function, default : undefined },
        onFocusIn       : { type : Function, default : undefined },
        onFocusOut      : { type : Function, default : undefined },
        onHide          : { type : Function, default : undefined },
        onItem          : { type : Function, default : undefined },
        onPaint         : { type : Function, default : undefined },
        onReadOnly      : { type : Function, default : undefined },
        onResize        : { type : Function, default : undefined },
        onShow          : { type : Function, default : undefined },

    },

    data : () => {
        return {
            instanceClass : ResourceFilter,

            configNames : [
                'activateOnMouseover',
                'adopt',
                'align',
                'anchor',
                'appendTo',
                'centered',
                'cls',
                'config',
                'constrainTo',
                'contentElementCls',
                'defaultBindProperty',
                'dock',
                'draggable',
                'eventStore',
                'floating',
                'hideAnimation',
                'htmlCls',
                'insertBefore',
                'insertFirst',
                'itemTpl',
                'listeners',
                'localeClass',
                'localizableProperties',
                'maskDefaults',
                'masked',
                'monitorResize',
                'multiSelect',
                'owner',
                'positioned',
                'preventTooltipOnTouch',
                'ripple',
                'rootElement',
                'scrollAction',
                'selectAllItem',
                'selected',
                'showAnimation',
                'store',
                'tab',
                'tag',
                'textAlign',
                'title',
                'toggleAllIfCtrlPressed',
                'weight'
            ],

            propertyConfigNames : [
                'alignSelf',
                'content',
                'dataset',
                'disabled',
                'extraData',
                'flex',
                'height',
                'hidden',
                'html',
                'id',
                'items',
                'margin',
                'maxHeight',
                'maxWidth',
                'minHeight',
                'minWidth',
                'onBeforeDestroy',
                'onBeforeHide',
                'onBeforeShow',
                'onCatchAll',
                'onDestroy',
                'onFocusIn',
                'onFocusOut',
                'onHide',
                'onItem',
                'onPaint',
                'onReadOnly',
                'onResize',
                'onShow',
                'readOnly',
                'scrollable',
                'tooltip',
                'width',
                'x',
                'y'
            ],

            propertyNames : [
                'anchorSize'
            ],

            eventNames : [
                'beforeDestroy',
                'beforeHide',
                'beforeShow',
                'catchAll',
                'destroy',
                'focusIn',
                'focusOut',
                'hide',
                'item',
                'paint',
                'resize',
                'show'
            ]
        };
    },

    /**
     * Called after the instance has been mounted
     */
    mounted() {
        const
            me = this,
            {
                createWidget,
                relayStores,
                watchProps
            }  = WrapperHelper(),
            {
                processCellContent,
                hasFrameworkRenderer
            }  = WrapperHelperVue2();

        me.instance = createWidget({
            me,
            props   : me.$props,
            data    : me.$data,
            emit    : me.$emit.bind(me),
            element : me.$el
        });

        const watcher = me.$watch.bind(me);
        watchProps(me, me.instance, me.$props, me.$data, watcher);
    },

    /**
     * Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
     */
    beforeDestroy() {
        if (this.instance) {
            this.instance.destroy();
        }
    }

};

</script>
